export const AUTH_TOKEN = "auth-token";
export const USER_ID = "ffr_id";
export const PAGE_REFERRER = "ffr_page_referrer";
export const CONNECT_FACEBOOK_TEAM_ID = "ffr_fb_teamId";
export const LINEUP_FORMATION = "ffr_lineup_formation";
export const LINEUP_POSITIONS = "ffr_lineup_positions";
export const LANGUAGE = "ffr_language";
